import { createSelector } from '@reduxjs/toolkit';
import { Indicator } from 'client/voladeum/indicators/types';
import { RootState } from 'store';

const indicatorsSlice = (state: RootState) => state.indicators;

export const selectIndicators = createSelector([indicatorsSlice], (state): Indicator[] => state);
